import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Partial, find } from 'lodash';
import {
  ModalSelect,
  BaseControl,
  TextArea,
  Textbox,
  DateTimePicker,
  Custom,
  Container,
} from '../../../dynamic-form';
import { Control } from '../../../models/formulario-dinamico.model';
import { CustomValidations } from '../../../directives/custom-validactions.directive';

@Injectable()
export class InputTableFormService {
  constructor() { }

  /**
   * Crea el control de pendiendo del tipo
   *
   * @param {Control} control
   * @param {*} templetesFomr
   * @param {*} value
   * @param {*} dataTemp
   * @returns {BaseControl<Partial>}
   * @memberof InputTableFormService
   */
  getControl(
    control: Control,
    templetesFomr: any,
    value: any,
    onFocustOut: (...arg: any[]) => void,
    dataTemp?: any
  ): BaseControl<Partial> {
    let field: BaseControl<any>;
    switch (control.tipo_campo.nombre) {
      case 'textarea':
        const textArea: TextArea = new TextArea({
          key: control.nombre_campo,
          label: control.label,
          size: 'col-md-' + control.espacio,
          rows: control.propiedades['rows'],
          class: {
            label: ['d-none'],
            input: []
          },
          placeholder: control.placeholder,
          disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
          value: '',
          order: control.orden + 1,
          condictions: control.validaciones.condiciones,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
          transform: control.propiedades['transform'] ? control.propiedades['transform'] : 'ninguna',
        });
        if (control.requerido) {
          textArea.validations.validators.push(Validators.required);
        }

        if (control.propiedades['max']) {
          textArea.validations.validators.push(Validators.maxLength(control.propiedades['max']));
          textArea.validations
            .messages['maxlength'] = 'El numero máximo de caracteres es de ' + control.propiedades['max'];
        }

        if (control.propiedades['min']) {
          textArea.validations.validators.push(Validators.minLength(control.propiedades['min']));
          textArea.validations
            .messages['minlength'] = 'El numero mínimo de caracteres es de ' + control.propiedades['min'];
        }

        field = textArea;
        break;
      case 'email':
        const email: Textbox = new Textbox({
          key: control.nombre_campo,
          label: control.label,
          type: control.tipo_campo.nombre,
          disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
          value: '',
          order: control.orden + 1,
          class: {
            label: ['d-none'],
            input: []
          },
          placeholder: control.placeholder,
          size: 'col-md-' + control.espacio,
          validations: {
            validators: [],
            messages: {}
          },
          condictions: control.validaciones.condiciones,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
        });
        if (control.requerido) {
          email.validations.validators.push(Validators.required);
        }

        if (control.propiedades['expresion']) {
          email.validations.validators.push(Validators.pattern(control.propiedades['expresion']));
          if (control.propiedades['mensajeExpresion']) {
            email.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
          }
        } else {
          email.validations.validators.push(Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/));
          if (control.propiedades['mensajeExpresion']) {
            email.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
          } else {
            email.validations.messages['pattern'] = 'Ingrese un email válido';
          }
        }

        field = email;
        break;
      case 'date-time-picker':
        const date: DateTimePicker = new DateTimePicker({
          key: control.nombre_campo,
          label: control.label,
          order: control.orden + 1,
          disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
          value: null,
          size: 'col-md-' + control.espacio,
          class: {
            label: ['d-none'],
            input: []
          },
          placeholder: control.placeholder,
          condictions: control.validaciones.condiciones,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
          inputActive: true
        });
        if (control.requerido) {
          date.validations.validators.push(Validators.required);
        }

        if (control.propiedades['fechaActualDesde']) {
          date.minDate = new Date();
          date.validations.messages['owlDateTimeMin'] = 'La fecha no puede ser menor a la fecha actual';
        } else if (control.propiedades['fechaDesde']) {
          date.minDate = control.propiedades['fechaDesde'];
          const dateString: string = new Date(control.propiedades['fechaHasta']).toLocaleDateString();
          date.validations.messages['owlDateTimeMin'] = 'La fecha no puede ser menor a ' + dateString;
        }

        if (control.propiedades['fechaActualHasta']) {
          date.maxDate = new Date();
          date.validations.messages['owlDateTimeMax'] = 'La fecha no puede ser mayor a la fecha actual';
        } else if (control.propiedades['fechaHasta']) {
          const dateString: string = new Date(control.propiedades['fechaHasta']).toLocaleDateString();
          date.maxDate = control.propiedades['fechaHasta'];
          date.validations.messages['owlDateTimeMax'] = 'La fecha no puede ser mayor a ' + dateString;
        }

        switch (control.propiedades['tipo']) {
          case 'calendar':
            date.pickerType = 'calendar';
            break;
          case 'timer':
            date.pickerType = 'timer';
            break;
          case 'range':
            date.selectMode = 'range';
            break;
          case 'rangeTime':
            date.pickerType = 'timer';
            date.selectMode = 'range';
            break;
          case 'rangeDate':
            date.pickerType = 'calendar';
            date.selectMode = 'range';
            break;
        }
        field = date;
        break;
      case 'ngSelect':
        let valueF: any = null;
        valueF = value;
        let ngSelect: Custom;
        ngSelect = new Custom({
          key: control.nombre_campo,
          label: control.label,
          order: control.orden + 1,
          size: 'col-md-' + control.espacio,
          template: templetesFomr.ngSelectTpl,
          class: {
            label: ['d-none'],
            input: []
          },
          placeholder: control.propiedades['placeholder_condicion'] ?
                        control.propiedades['placeholder_condicion']
                        : control.placeholder,
          disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
          value: valueF,
          options: control.propiedades['options'],
          validations: {
            validators: []
          },
          condictions: control.validaciones.condiciones,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
        });

        if (control.requerido) {
          ngSelect.validations.validators.push(Validators.required);
        }
        field = ngSelect;
        break;
      case 'number':
        const number: Textbox = new Textbox({
          key: control.nombre_campo,
          label: control.label,
          type: control.tipo_campo.nombre,
          disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
          value: '',
          order: control.orden + 1,
          class: {
            label: ['d-none'],
            input: []
          },
          placeholder: control.placeholder,
          size: 'col-md-' + control.espacio,
          condictions: control.validaciones.condiciones,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
          thousandsSeparator: control.propiedades['separadorMiles'] ? control.propiedades['separadorMiles'] : null,
          decimalSeparator: control.propiedades['separadorDecimales'] ? control.propiedades['separadorDecimales'] : null
        });
        if (control.requerido) {
          number.validations.validators.push(Validators.required);
        }

        if (control.propiedades['max']) {
          if (!control.propiedades['menorQue']) {
            if (!control.propiedades['separadorMiles']) {
              number.validations.validators.push(Validators.max(control.propiedades['max']));
            } else {
              number.validations.validators.push(
                CustomValidations.customMaxEqual(
                  control.propiedades['max'],
                  control.propiedades['separadorMiles'],
                  control.propiedades['separadorDecimales']
                )
              );
            }
            number.validations.messages['max'] = 'Debe ser menor o igual a ' + control.propiedades['max'];
          } else {
            number.customMax = control.propiedades['max'];
            number.validations.messages['customMax'] = 'Debe ser menor a ' + control.propiedades['max'];
          }
        }

        if (control.propiedades['min']) {
          if (!control.propiedades['mayorQue']) {
            if (!control.propiedades['separadorMiles']) {
              number.validations.validators.push(Validators.min(control.propiedades['min']));
            } else {
              number.validations.validators.push(
                CustomValidations.customMinEqual(
                  control.propiedades['min'],
                  control.propiedades['separadorMiles'],
                  control.propiedades['separadorDecimales']
                )
              );
            }
            number.validations.messages['min'] = 'Debe ser mayor o igual a ' + control.propiedades['min'];
          } else {
            number.customMin = control.propiedades['min'];
            number.validations.messages['customMin'] = 'Debe ser mayor a ' + control.propiedades['min'];
          }
        }

        if (control.propiedades['cantidadDecimales']) {
          number.customDecimalMax = control.propiedades['cantidadDecimales'];
          number.validations.messages['customDecimalMax'] = 'Máximo ' + control.propiedades['cantidadDecimales'] +
                                                            ' decimales permitidos';
        }

        if (!control.propiedades['enteros']) {
          if (control.propiedades['expresion']) {
            number.validations.validators.push(Validators.pattern(control.propiedades['expresion']));
            if (control.propiedades['mensajeExpresion']) {
              number.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
            }
          }
        } else {
          number.validations.validators.push(Validators.pattern(/^-?\d+$/));
          number.validations.messages['pattern'] = 'Solo numeros enteros';
        }

        field = number;
        break;
      case 'label':
        const label: Custom = new Custom({
          key: control.nombre_campo,
          order: control.orden + 1,
          size: 'col-md-' + control.espacio,
          sizeFont: control.propiedades['sizeFont'],
          template: templetesFomr.labelTpl,
          hiddenLabel: true,
          label: control.label,
          condictions: control.validaciones.condiciones,
        });
        field = label;
        break;
      case 'coordenadas':
        const coordinates: Container = new Container({
          class: 'form-row col-12',
          order: control.orden + 1,
          label: control.label,
          controls: [
            new Textbox({
              key: control.propiedades['fieldName']['latitud'],
              label: 'Latitud',
              type: 'text',
              disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
              value: value ?
                      value['latitud'] ?
                        value['latitud']
                      : ''
                     : '',
              class: {
                label: ['d-none'],
                input: []
              },
              placeholder: 'Latitud',
              size: 'col-md-3',
              condictions: control.validaciones.condiciones,
              readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
            }),
            new Textbox({
              key: control.propiedades['fieldName']['longitud'],
              label: 'Longitud',
              type: 'text',
              disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
              value: value ?
                      value['longitud'] ?
                        value['longitud']
                      : ''
                     : '',
              placeholder: 'Longitud',
              class: {
                label: ['d-none'],
                input: []
              },
              size: 'col-md-3',
              condictions: control.validaciones.condiciones,
              readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
            }),
            new Textbox({
              key: control.propiedades['fieldName']['altura'],
              label: 'Altura',
              type: 'text',
              disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
              value: value ?
                      value['altura'] ?
                        value['altura']
                      : ''
                     : '',
              placeholder: 'Altura',
              class: {
                label: ['d-none'],
                input: []
              },
              size: 'col-md-3',
              condictions: control.validaciones.condiciones,
              readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
            }),
            new Custom({
              key: control.nombre_campo + '_btn',
              order: control.orden + 1,
              size: 'col-md-3',
              template: templetesFomr.buttonCordenadasTpl,
              skipDisabled: true,
              hiddenLabel: true,
              label: control.label,
              disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
              parameters: {
                nameCoordinates: control.nombre_campo,
              },
              condictions: control.validaciones.condiciones,
            }),
          ]
        });
        if (control.requerido) {
          coordinates.controls[0].validations.validators.push(Validators.required);
          coordinates.controls[1].validations.validators.push(Validators.required);
        }
        field = coordinates;
        break;
      case 'checkbox':
        const checkbox: Textbox = new Textbox({
          key: control.nombre_campo,
          order: control.orden + 1,
          size: 'col-md-' + control.espacio,
          type: control.tipo_campo.nombre,
          disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
          label: control.label,
          condictions: control.validaciones.condiciones,
          value: value ? value : control.propiedades['default'] ? undefined : false,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
        });
        if (control.requerido) {
          checkbox.validations.validators.push(Validators.required);
          checkbox.validations.messages['required'] = 'El campo es requerido.';
        }
        if (
          control.propiedades['default'] &&
          control.propiedades['default'] === 'seleccionado' &&
          typeof value === 'undefined'
        ) {
          checkbox.default = true;
        }
        field = checkbox;
        break;
      default:
        const text: Textbox = new Textbox({
          key: control.nombre_campo,
          label: control.label,
          type: control.tipo_campo.nombre,
          disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
          value: '',
          order: control.orden + 1,
          placeholder: control.placeholder,
          class: {
            label: ['d-none'],
            input: []
          },
          size: 'col-md-' + control.espacio,
          condictions: control.validaciones.condiciones,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
          transform: control.propiedades['transform'] ? control.propiedades['transform'] : 'ninguna',
        });
        if (control.requerido) {
          text.validations.validators.push(Validators.required);
        }

        if (control.propiedades['max']) {
          text.validations.validators.push(Validators.maxLength(control.propiedades['max']));
          text.validations.messages['maxlength'] = 'El numero máximo de caracteres es de ' + control.propiedades['max'];
        }

        if (control.propiedades['min']) {
          text.validations.validators.push(Validators.minLength(control.propiedades['min']));
          text.validations.messages['minlength'] = 'El numero mínimo de caracteres es de ' + control.propiedades['min'];
        }

        if (control.propiedades['expresion']) {
          text.validations.validators.push(Validators.pattern(control.propiedades['expresion']));
          if (control.propiedades['mensajeExpresion']) {
            text.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
          }
        }

        field = text;
        break;
    }
    if (value && control.tipo_campo.nombre !== 'ngSelect') {
      field.value = value;
    }
    field.idInput = control.nombre_campo + '_table';
    field.onFocusOut = onFocustOut;
    return field;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/input-table/shared/input-table.form.service.ts